const Bookmark = () => (
  <>
    <path
      fill="currentColor"
      d="m12 17.423-3.738 1.608q-.808.348-1.535-.134T6 17.552V6.116q0-.69.463-1.153A1.57 1.57 0 0 1 7.615 4.5h8.77q.69 0 1.152.463.463.462.463 1.152v11.437q0 .864-.727 1.345-.727.482-1.534.134zm0-1.123 4.134 1.784q.308.135.587-.057a.6.6 0 0 0 .279-.52V6.117a.59.59 0 0 0-.192-.424.59.59 0 0 0-.424-.192H7.616a.59.59 0 0 0-.424.192.59.59 0 0 0-.192.423v11.393a.6.6 0 0 0 .279.519.57.57 0 0 0 .587.057zm0-10.8H7h10z"
    />
  </>
)
export default Bookmark
